export default __webpack_public_path__ + "3792049a94821ede562d580ded70135e.ttf";